/**
 * The demo booking link every "Get a demo" on the marketing pages points at. One copy, so a nav, a
 * footer and a hero cannot drift apart. Kept out of the `'use client'` nav module on purpose: a
 * server component importing a plain value from a client module receives a client reference, not
 * the string.
 */
export const DEMO_URL = 'https://calendly.com/d/dtb8-rrh-5fw/sonicjobs-careergpt-ai-candidate-visibility-intro'
